import type React from 'react';

import { type TypographyProps } from '@mui/material';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import TMXCircularProgress from 'components/progress/TMXCircularProgress';
import { useStyles } from 'components/typography/progress/styles';

interface TMXProgressTypographyProps extends TypographyProps {
  loading?: boolean;
}

const TMXProgressTypography: React.FC<React.PropsWithChildren<TMXProgressTypographyProps>> = ({
  children,
  loading,
  ...props
}) => {
  const { classes } = useStyles();
  return (
    <>
      {loading ? (
        <Grid container alignItems="center" justifyContent="center">
          <Grid item>
            <TMXCircularProgress className={classes.loader} size={20} />
          </Grid>
        </Grid>
      ) : (
        <Typography {...props}>{children}</Typography>
      )}
    </>
  );
};

export default TMXProgressTypography;
